<template>
   <div>
      <vs-button color="success" size="small" @click="getAditionalContacts()">Contactos adicionales</vs-button>
      <vs-popup title="Contactos adicionales" class="extended-popup header-primary" :active.sync="popupApplicantContactsActive">
         <div v-if="requestMade">           
            <label><strong>Aviso:</strong> Los recordatorios de pago serán enviados a estas direcciones</label><br>
            <vs-button color="success" size="small" @click="newApplicantContact()">Agregar</vs-button>
            <vs-table class="mt-2" :data="allApplicantContacts" noDataText="No hay datos disponibles">
               <template slot="thead">
                  <vs-th>Nombre</vs-th>
                  <vs-th>Email</vs-th>
                  <vs-th>Teléfono</vs-th>
                  <vs-th>Puesto</vs-th>
                  <vs-th>¿Activo?</vs-th>
                  <vs-th>Acciones</vs-th>
               </template>
               <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                     <vs-td>{{ tr.complete_name }}</vs-td>
                     <vs-td>
                        <EmailableStatusComponent :source="tr.emailable_verification_response">
                           <template slot="email">
                              {{ tr.email }}
                           </template>
                        </EmailableStatusComponent>
                     </vs-td>
                     <vs-td>{{ tr.phone_data.complete_phone }}</vs-td>
                     <vs-td>{{ tr.position }}</vs-td>
                     <vs-td>
                        {{ booleanFormat(tr.is_active) }}
                     </vs-td>
                     <vs-td>
                        <div class="flex flex-wrap">
                           <vs-button radius color="dark" icon-pack="feather" icon="icon-edit" @click="editApplicantContact(tr)"></vs-button>
                           <vs-button class="ml-2" radius color="danger" icon-pack="feather" icon="icon-trash" @click="confirmDeleteApplicantContact(tr.id)"></vs-button>
                        </div>
                     </vs-td>
                  </vs-tr>
               </template>
            </vs-table>
         </div>
         <vs-popup title="Nuevo Contacto" class="extended-popup header-primary" :active.sync="popupNewApplicantContactActive">
            <div class="skinny row">
                  <div class="col-xs-12 col-md-6">
                     <vs-input
                        label="Nombre"
                        class="w-full"
                        type="text"
                        v-model.lazy="completeName"
                        name="completeName"
                        v-validate="'required'"
                        autocomplete="off"
                        placeholder="Ingresa"
                        :danger="hasError('completeName')"
                        :danger-text="errorText('completeName')"
                        :success="isSuccess('completeName')"
                     />
                  </div>
                  <div class="col-xs-12 col-md-6">
                     <label>Teléfono</label>
                     <div class="flex">
                        <vue-country-code
                           name="dialCode"
                           class="vs-custom"
                           data-vv-name="dialCode"
                           :enableSearchField="true"
                           searchPlaceholderText="Buscar código de país"
                           :enabledCountryCode="true"
                           @onSelect="onSelect"
                           :preferredCountries="['MX']"
                           :danger="hasError('dialCode')"
                           :danger-text="errorText('dialCode')"
                           :success="isSuccess('dialCode')"
                        >
                        </vue-country-code>
                        <vs-input
                           class="w-full"
                           name="phone"
                           type="tel"
                           v-validate="'required|numeric'"
                           v-model.lazy="phone"
                           :danger="hasError('phone')"
                           :danger-text="errorText('phone')"
                           :success="isSuccess('phone')"
                           icon-pack="feather"
                           placeholder="(Requerido)"
                        />
                     </div>
                  </div>
            </div>
            <div class="skinny row mt-5">
                  <div class="col-xs-12 col-md-6">
                     <vs-input 
                     label="Email" 
                     class="w-full" 
                     type="text" 
                     v-model.lazy="email"
                     v-validate="'required|email'" 
                     :danger="hasError('email')"
                     :danger-text="errorText('email')"
                     :success="isSuccess('email')"
                     name="email" />
                  </div>
                  <div class="col-xs-12 col-md-6">
                     <vs-input 
                     label="Puesto" 
                     class="w-full" 
                     type="text" 
                     v-model.lazy="position"
                     :danger="hasError('position')"
                     :danger-text="errorText('position')"
                     :success="isSuccess('position')"
                     name="position" />
                  </div>
            </div>
            <div class="skinny row mt-5">
                  <div class="col-xs-12 col-md-6">
                     <label>
                        ¿Activo?
                     </label>
                     <vs-switch color="success" v-model="is_active" />
                  </div>
            </div>
            <div class="skinny row">
                  <div class="col-md-2">
                     <vs-button v-if="applicantContactIdToEdit"  color="success" class="mt-6" @click="updateContact()">Actualizar</vs-button>
                     <vs-button v-else  color="success" class="mt-6" @click="saveContact()">Guardar</vs-button>
                  </div>
            </div>
         </vs-popup>
      </vs-popup>
   </div>
</template>
  
<script>
import dateHelper from "@mixins/dateHelper";
import formatHelper from "@mixins/formatHelper";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";

export default {
   name: "ApplicantContacts",
   props: ["client_id"],
   mixins: [formatHelper, dateHelper],
   components: {
      Datepicker
   },
   data() {
      return {
         es: es,
         loading: false,
         popupApplicantContactsActive: false,
         popupNewApplicantContactActive: false,
         countryCallingCode: '+52',
         phone: null,
         position: '',
         completeName: '',
         is_active: true,
         email: '',
         contactIdToDelete: -1,
         allApplicantContacts: [],
         requestMade: false,
         applicantContactIdToEdit: null
      };
   },
   methods: {
      async getAditionalContacts() {
         await this.getContacts();
         this.popupApplicantContactsActive = true;
      },
      onSelect({ dialCode }) {
         this.countryCallingCode = `+${dialCode}`
      },
      async getContacts() {
         this.resetValues();
         this.showLoading(true);
         this.requestMade = false;
         await axios
            .post("/api/cobranza/applicantContactsList", {
               client_id: this.client_id,
            })
            .then((response) => {
               this.allApplicantContacts = response.data;
               this.requestMade = true;
            })
            .catch((error) => {
               this.requestMade = false;
               if (error.response.data.message !== undefined) {
                  this.errorNotif("Aviso", error.response.data.message, 4000);
               } else {
                  this.errorNotif(
                     "Aviso",
                     "Ha ocurrido un error intente mas tarde.",
                     4000
                  );
               }
            });
         this.requestMade = true;
         this.showLoading(false);
      },
      newApplicantContact() {
         this.completeName = '';
         this.email = '';
         this.is_active = true;
         this.position = '';
         this.phone = null;
         this.countryCallingCode = '+52';
         this.contactIdToDelete = -1;
         this.applicantContactIdToEdit = null;
         this.popupNewApplicantContactActive = true;
      },
      async saveContact() {
         this.$validator.validateAll().then(result => {
            if (result) {
               this.showLoading(true);
               axios.post("/api/cobranza/postApplicantContact", {
                  client_id: this.client_id,
                  email: this.email,
                  complete_name: this.completeName,
                  position: this.position,
                  country_calling_code: this.countryCallingCode,
                  phone: this.phone,
                  is_active: this.is_active,
                  action: "save",
               })
                  .then((response) => {
                     this.resetValues();
                     this.allApplicantContacts = response.data;
                     this.popupNewApplicantContactActive = false;
                     this.showLoading(false);
                     this.successNotif("Aviso", "Contacto guardado exitosamente", 4000);
                  })
                  .catch((error) => {
                     this.showLoading(false);
                     this.errorNotif(
                        "Aviso",
                        "Ha ocurrido un error intente mas tarde.",
                        4000
                     );
                  });
            }
         });
      },
      confirmDeleteApplicantContact(id) {
        this.contactIdToDelete = id;
        this.$vs.dialog({
          type: "confirm",
          color: "danger",
          title: `Aviso`,
          text: "¿Estas seguro de querer eliminar este contacto del solicitante?",
          acceptText: "Confirmar",
          cancelText: "Cancelar",
          accept: this.deleteApplicantContact,
        });
      },
      async deleteApplicantContact() {
         this.showLoading(true);
         await axios
            .post("/api/cobranza/postApplicantContact", {
               client_id: this.client_id,
               applicant_contact_id: this.contactIdToDelete,
               action: "delete",
            })
            .then((response) => {
               this.resetValues();
               this.allApplicantContacts = response.data;
               this.popupNewApplicantContactActive = false;
               this.successNotif("Aviso", "Contacto eliminado exitosamente", 4000);
            })
            .catch((error) => {
               this.errorNotif(
                  "Aviso",
                  "Ha ocurrido un error intente mas tarde.",
                  4000
               );
            });
         this.showLoading(false);
      },
      editApplicantContact(contact) {
         this.applicantContactIdToEdit = contact.id;
         this.email = contact.email
         this.completeName = contact.complete_name;
         this.position = contact.position;
         this.countryCallingCode = contact.phone_data.country_calling_code;
         this.is_active = contact.is_active;
         this.phone = contact.phone_data.phone;
         this.popupNewApplicantContactActive = true;
      },
      async updateContact() {
         this.$validator.validateAll().then(result => {
            if (result) {
               this.showLoading(true);
               axios.post("/api/cobranza/postApplicantContact", {
                  client_id: this.client_id,
                  applicant_contact_id: this.applicantContactIdToEdit,
                  email: this.email,
                  complete_name: this.completeName,
                  position: this.position,
                  country_calling_code: this.countryCallingCode,
                  phone: this.phone,
                  is_active: this.is_active,
                  action: "update",
               })
                  .then((response) => {
                     this.resetValues();
                     this.allApplicantContacts = response.data;
                     this.popupNewApplicantContactActive = false;
                     this.showLoading(false);
                     this.successNotif("Aviso", "Contacto editado exitosamente", 4000);
                  })
                  .catch((error) => {
                     this.showLoading(false);
                     this.errorNotif(
                        "Aviso",
                        "Ha ocurrido un error intente mas tarde.",
                        4000
                     );
                  });
            }
         });
      },
      hasError(val) {
         return this.errors.has(val)
      },
      errorText(val) {
         return this.errors.first(val)
      },
      isSuccess(val) {
         let ff = this.fields[val]
         return ff && ff.required && ff.valid
      },
      resetValues() {
         this.completeName = '';
         this.email = '';
         this.position = '';
         this.phone = null;
         this.countryCallingCode = '+52';
         this.contactIdToDelete = -1;
         this.allApplicantContacts = [];
         this.applicantContactIdToEdit = null;
      },
   },
};
</script>
  